<template>
    <Modal @shown="shown" @hidden="hidden" ref="modal" modalClass="modal-md" @submit="submit">
        <template #title>
            <template v-if="role && !readonly">
                {{ i18n('Edit {name}').replace('{name}', i18n('Role')) }}
            </template>
            <template v-else-if="role">
                {{ i18n('{name} Detail').replace('{name}', i18n('Role')) }}
            </template>
            <template v-else>
                {{ i18n('Add {name}').replace('{name}', i18n('Role')) }}
            </template>
        </template>

        <div class="alert alert-danger mb-2" v-if="errorMessage">{{ errorMessage }}</div>

        <div class="row g-2">
            <div class="col-12">
                <Field v-model="formData.name" :errorMessage="errorMessages.name" :label="i18n('Name')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'text'" />
            </div>
            <div class="col-12">
                <Field v-model="formData.userType" :errorMessage="errorMessages.userType" :label="i18n('User Type')"
                    :disabled="submitted" :required="true" :type="readonly ? 'readonly' : 'dictionary'"
                    rest="types/users" format="object" />
            </div>
            <div v-if="$root?.features?.roles?.team?.enabled" class="col-12">
                <Field v-model="formData.team" :errorMessage="errorMessages.team" :label="i18n('Team')"
                    :disabled="submitted" :type="readonly ? 'readonly' : 'dictionary'" rest="teams" format="object" />
            </div>
            <div v-if="formData.team" class="col-12">
                <Field v-model="formData.is_default_for_team" :label="i18n('Default Team Role')" :disabled="submitted"
                    :type="readonly ? 'readonly' : 'checkbox'" />
            </div>
        </div>

        <template #footer>
            <div class="row">
                <template v-if="!readonly">
                    <div class="col text-start">
                        <button type="button" class="btn btn-danger" @click="hide">
                            {{ i18n('Cancel') }}
                        </button>
                    </div>
                    <div class="col text-end">
                        <button type="submit" class="btn btn-primary text-white" :disabled="submitted">
                            {{ i18n('Confirm') }}
                        </button>
                    </div>
                </template>
                <div class="col text-end" v-else>
                    <button type="button" @click="hide" class="btn btn-outline-dark btn-sm me-2">
                        {{ i18n('Close') }}
                    </button>
                </div>
            </div>
        </template>
    </Modal>
</template>

<script>
import api from "@/api.js";
import { duplicate, } from "@/tools/object.js";
import Modal from "@/components/common/layout/Modal.vue";
import Field from "@/components/common/form/Field.vue";
import { translatedErrorMessage, } from "@/tools/errorHandling.js";

export default {
    components: {
        Modal,
        Field,
    },
    data() {
        return {
            roleId: null,
            role: null,
            submitted: false,
            formData: {},
            errorMessages: {},
            errorMessage: '',
        };
    },
    emits: [
        'shown',
        'hidden',
        'created',
        'updated',
    ],
    computed: {
        readonly() {
            return this.role
                && this.role.acl?.update !== true;
        },
    },
    methods: {
        show(roleId) {
            this.roleId = roleId;
            this.role = null;
            this.load().then(() => {
                this.submitted = false;
                this.$refs['modal'].show();
                this.errorMessages = {};
                this.errorMessage = '';

                if (this.role) {
                    this.formData = duplicate(this.role);
                } else {
                    this.formData = {};
                }
            });
        },
        load() {
            if (!this.roleId) return Promise.resolve();
            let promise = api.get(`roles/${this.roleId}`, { acl: 'role' });

            promise.then(role => {
                this.role = role;
            });

            return promise;
        },
        hide() {
            this.$refs['modal'].hide();
        },
        shown() {
            this.$emit('shown');
        },
        hidden() {
            this.$emit('hidden');
        },
        submit() {
            this.submitted = true;
            this.errorMessages = {};
            this.errorMessage = '';

            const postFormData = duplicate(this.formData);
            let savePromise;

            if (!this.role) {
                savePromise = api.post(`roles`, postFormData);
            } else {
                savePromise = api.put(`roles/${this.role.id}`, postFormData);
            }

            savePromise.then(role => {
                if (!this.role) {
                    this.$emit('created', role);
                } else {
                    this.$emit('updated', role);
                }

                this.hide();
                api.clearCache();
            }).catch((errorMessage) => {
                this.errorMessage = translatedErrorMessage(errorMessage);
                this.submitted = false;
            });
        }
    }
}
</script>